import { z } from 'zod';

import { PaywallValueSchema } from '@/shared/types/report-types';

export const SessionSchemas = {
  navigationHistory: z.array(z.string()),
  paywallActionValue: PaywallValueSchema,
} as const;

export type SessionStorageKey = keyof typeof SessionSchemas;

export type SessionStorageTypeMap = {
  [K in SessionStorageKey]: z.infer<(typeof SessionSchemas)[K]>;
};
